export function useBlogFormatter() {
    const splitParagraphs = (content: string | undefined): string[] => {
        if (!content) {
            return []
        }
        return content.split('\n\n').filter(p => p.trim())
    }

    const inlineFormat = (value: string): string => {
        let out = value.replace(/`([^`]+)`/g, '<code>$1</code>')
        out = out.replace(/\*\*([^*]+)\*\*/g, '<strong>$1</strong>')
        // Italic: single *…* runs after bold replacement, so paired asterisks are gone.
        out = out.replace(/\*([^*\n]+?)\*/g, '<em>$1</em>')
        out = out.replace(
            /\[([^\]]+)\]\((https?:\/\/[^)]+)\)/g,
            '<a href="$2" target="_blank" rel="noopener noreferrer">$1</a>'
        )
        out = out.replace(/\[([^\]]+)\]\((\/[^)]+)\)/g, '<a href="$2">$1</a>')
        return out
    }

    const formatContent = (text: string): string => {
        const lines = text.split('\n')
        const hasUnorderedList = lines.some(line => /^- /.test(line.trim()))
        const hasOrderedList = lines.some(line => /^\d+\. /.test(line.trim()))

        if (hasUnorderedList || hasOrderedList) {
            const listItems: string[] = []
            let introText = ''

            for (const line of lines) {
                const trimmedLine = line.trim()
                if (/^- /.test(trimmedLine)) {
                    listItems.push(`<li>${inlineFormat(trimmedLine.substring(2))}</li>`)
                } else if (/^\d+\. /.test(trimmedLine)) {
                    listItems.push(`<li>${inlineFormat(trimmedLine.replace(/^\d+\. /, ''))}</li>`)
                } else if (trimmedLine && listItems.length === 0) {
                    introText = inlineFormat(trimmedLine)
                }
            }

            const listTag = hasOrderedList ? 'ol' : 'ul'
            const listHtml = `<${listTag}>${listItems.join('')}</${listTag}>`
            return introText ? `${introText}${listHtml}` : listHtml
        }

        return inlineFormat(text)
    }

    return { splitParagraphs, formatContent }
}

export interface PostSection {
    title: string
    content: string
}

export interface PostSections {
    intro?: PostSection
    [key: string]: PostSection | undefined
}

export interface PostCaptions {
    [key: string]: string | undefined
}
